var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{style:(_vm.globalFontStyle),attrs:{"id":"app"}},[_c('router-view'),(_vm.newsShow)?_c('div',{staticClass:"goods-new",on:{"click":_vm.handleCloseModal}},[_c('img',{attrs:{"src":_vm.url,"alt":""}})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }